import { render, staticRenderFns } from "./hanwang.vue?vue&type=template&id=535b55c2&scoped=true"
import script from "./hanwang.vue?vue&type=script&lang=js"
export * from "./hanwang.vue?vue&type=script&lang=js"
import style0 from "./hanwang.vue?vue&type=style&index=0&id=535b55c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b55c2",
  null
  
)

export default component.exports